import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementReportsIndexScene from 'scenes/management/reports'
import ManagementReportsScheduleEditScene from 'scenes/management/reports/schedule/edit'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_REPORTS_INDEX]: {
		component: ManagementReportsIndexScene,
	},
	[AppRoutes.MANAGEMENT_REPORTS_SCHEDULE_EDIT]: {
		component: ManagementReportsScheduleEditScene,
	},
}

const ManagementReportsNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementReportsNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementReportsNavigator
